import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import * as reducers from '../reducers';
import promiseMiddleware from '../middleware/promise';
import awaitPendingActionsMiddleware from '../middleware/await-pending-actions';
import apiMiddleware from '../middleware/api';
import analyticsMiddleware from '../middleware/analytics';

const getMiddleware = apiService => (
  process.browser
    ? [apiMiddleware(apiService), promiseMiddleware, analyticsMiddleware]
    : [apiMiddleware(apiService), awaitPendingActionsMiddleware, promiseMiddleware]
);

export default (apiService, state = {}) => {
  const composeEnhancers =
    // eslint-disable-next-line no-underscore-dangle
    (process.browser && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  return createStore(
    combineReducers(reducers),
    state,
    composeEnhancers(applyMiddleware(...getMiddleware(apiService)))
  );
};



// WEBPACK FOOTER //
// ./src/universal/ui/utils/configure-store.js